(() => {
 const init = () => document.querySelectorAll('[data-editorial-product]').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready='true';
  const strings=JSON.parse(root.querySelector('[data-ep-strings]').textContent);
  const variants=JSON.parse(root.querySelector('[data-ep-variants]').textContent);
  const panel=root.querySelector('.ep-panel'),form=panel.querySelector('form'),id=form.querySelector('[data-ep-id]'),add=form.querySelector('[data-ep-add]');
  const toggle=panel.querySelector('[data-ep-toggle]'),body=panel.querySelector('.ep-panel-body');
  const sizeCopy=panel.querySelector('.ep-size-table'),sizeTable=sizeCopy?.querySelector('table');
  if(sizeTable){
   const cells=[...sizeTable.querySelectorAll('tr')].flatMap(row=>[...row.cells].slice(1)).filter(cell=>/^\d+(?:\.\d+)?$/.test(cell.textContent.trim())).map(cell=>({cell,cm:cell.textContent.trim()}));
   if(cells.length){
    const units=document.createElement('div');units.className='ep-size-units';units.setAttribute('role','group');units.setAttribute('aria-label','cm / inch');
    ['cm','inch'].forEach(unit=>{
     const button=document.createElement('button');button.type='button';button.textContent=unit;button.dataset.epUnit=unit;button.setAttribute('aria-pressed',String(unit==='cm'));
     button.addEventListener('click',()=>{
      cells.forEach(({cell,cm})=>{cell.textContent=unit==='cm'?cm:(Number(cm)/2.54).toFixed(1);});
      units.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
     });units.append(button);
    });sizeCopy.prepend(units);
   }
  }
  toggle.addEventListener('click',()=>{
   const collapsed=panel.classList.toggle('is-collapsed');
   toggle.setAttribute('aria-expanded',String(!collapsed));
   toggle.setAttribute('aria-label',collapsed?strings.show:strings.hide);
   toggle.querySelector('span').textContent=collapsed?'⌃':'⌄';
   body.inert=collapsed;
  });
  const update=()=>{
   const values=[0,1].map(i=>root.querySelector(`[data-ep-option="${i}"]:checked`)?.value);
   const variant=variants.find(v=>v.options.every((o,i)=>o===values[i]));
   root.dataset.color=values[0].toUpperCase();
   root.querySelectorAll('[data-ep-color]').forEach(g=>{g.hidden=g.dataset.epColor!==root.dataset.color;if(!g.hidden)g.scrollLeft=0;});
   id.value=variant?.id||'';add.disabled=!variant?.available;
   add.textContent=variant?.available?strings.add:variant?strings.sold_out:strings.unavailable;
   if(variant){root.querySelector('[data-ep-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'ja',{style:'currency',currency:root.dataset.currency||'JPY'}).format(variant.price/100);const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
  };
  root.addEventListener('change',e=>{if(e.target.matches('[data-ep-option]'))update();});
  const placePanel=()=>{
   if(!root.isConnected)return;
   if(matchMedia('(max-width:749px)').matches){panel.style.removeProperty('bottom');return;}
   let inset=24;
   document.querySelectorAll('iframe').forEach(frame=>{
    if(!frame.src.includes('preview-bar'))return;
    const rect=frame.getBoundingClientRect();
    if(rect.height>0&&rect.top<innerHeight&&rect.bottom>=innerHeight-2)inset=Math.max(inset,rect.height<=150?innerHeight-rect.top+16:80);
   });
   panel.style.bottom=Math.max(inset,innerHeight-root.getBoundingClientRect().bottom+16)+'px';
  };
  let placementFrame;
  const schedulePlacement=()=>{cancelAnimationFrame(placementFrame);placementFrame=requestAnimationFrame(placePanel);};
  document.addEventListener('scroll',schedulePlacement,{passive:true,capture:true});
  window.addEventListener('resize',schedulePlacement);
  const panelObserver=new ResizeObserver(schedulePlacement);panelObserver.observe(root);
  document.querySelectorAll('iframe').forEach(frame=>{if(frame.src.includes('preview-bar'))panelObserver.observe(frame);});
  placePanel();
  const dialog=root.querySelector('dialog'),zoom=dialog.querySelector('img');let index=0,photos=[],opener;
  const show=n=>{index=(n+photos.length)%photos.length;const img=photos[index].querySelector('img');zoom.src=img.currentSrc||img.src;zoom.alt=img.alt;dialog.querySelector('[data-ep-count]').textContent=`${index+1} / ${photos.length}`;};
  root.addEventListener('click',e=>{const button=e.target.closest('[data-ep-photo]');if(!button)return;photos=[...root.querySelectorAll('.ep-color-gallery:not([hidden]) [data-ep-photo]')];opener=button;show(photos.indexOf(button));dialog.showModal();});
  dialog.querySelector('[data-ep-close]').addEventListener('click',()=>dialog.close());
  dialog.querySelector('[data-ep-prev]').addEventListener('click',()=>show(index-1));dialog.querySelector('[data-ep-next]').addEventListener('click',()=>show(index+1));
  dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}});
  dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));let startX;
  dialog.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;},{passive:true});dialog.addEventListener('touchend',e=>{if(startX==null)return;const delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)>50)show(index+(delta<0?1:-1));startX=null;},{passive:true});
 });
 init();document.addEventListener('shopify:section:load',init);
})();

